var unstyledAnchor = 'fx_e395032e_1mi6qzi0';

export { unstyledAnchor };
//# sourceMappingURL=primitive-anchor.vanilla.mjs.map
